import React from "react";
import { RestrictedDomains } from "../Components/Signup/RestrictedDomain";
import { toast } from "react-toastify";
import { Urls } from "../Urls";
import transport_alt from "../Content/images/transporter_logo.png";
import { auth, logout } from "./firebase/firebase";
import mixpanel from "mixpanel-browser";

import { CLIENT_REDIRECT_BASE } from "../env.config";
export * from "../env.config";

/**
 * Constants related to email validation and restricted domains.
 */
export const Constants = {
 Email: {
  regex: /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/,
},
  restrictedDomains: RestrictedDomains,
};

/**
 * Encrypts or decrypts a transporter ID.
 *
 * @param {string} [transporterID=""] - The transporter ID to be encrypted or decrypted.
 * @param {boolean} shouldEncode - Determines if the ID should be encoded or decoded.
 * @returns {string} The encrypted or decrypted transporter ID.
 */
export const encryptor = (transporterID = "", shouldEncode) => {
  let characters = "QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm".split("");
  const generateRandomCharcter = () =>
    characters[Math.floor(Math.random() * characters.length)];

  if (shouldEncode) {
    let k = transporterID.split("");
    let encodedID = "";
    k.forEach((item, index) => {
      encodedID += item;
      for (let i = 0; i <= index; i++) {
        encodedID += generateRandomCharcter();
      }
    });
    return encodedID;
  } else {
    let decodedID = "";
    let startIndex = 0,
      nextIndex = 2;
    while (transporterID.length > startIndex) {
      decodedID += transporterID[startIndex];
      startIndex += nextIndex;
      nextIndex++;
    }
    return decodedID;
  }
};

/**
 * Formats a date input for display with time and timezone.
 *
 * @param {string|Date} inputdate - The date to be formatted.
 * @returns {React.ReactElement} A JSX element displaying the formatted date and time.
 */
export const DateFormatter = (inputdate) => {
  if (inputdate) {
    let date = new Date(inputdate);
    // timezone
    let datefortimezone = new Date(inputdate);
    let new_date = datefortimezone.toString();
    let dateparts = new_date.split(" ");
    let str1 = dateparts[6];
    let str2 = dateparts[7];
    let str3 = dateparts[8];
    let space = " ";
    let timezone = str1.concat(space, str2, space, str3);
    // timezone
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();
    let time = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    let milliseconds = date.getMilliseconds();

    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return (
      <>
        <div>
          <b>Date:</b>
          {dt + "-" + month + "-" + year}
        </div>
        <div>
          <b>Time{timezone}:</b>
          {time + ":" + milliseconds}
        </div>
      </>
    );
  }
};

/**
 * Formats a number with commas for thousands separators.
 *
 * @param {number|string} x - The number to be formatted.
 * @returns {string} The formatted number with commas.
 */

export const numberWithCommas = (x) => {
  if (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

/**
 * Formats a number according to the Indian numbering system with commas.
 *
 * @param {number|string} x - The number to be formatted.
 * @returns {string} The formatted number with Indian commas.
 */
export const indiannumberwithcommas = (x) => {
  let number = Number(x);

  if (isNaN(number) || !isFinite(number)) {
    // console.log("Invalid number for formating with indian commas.", number);
    return "0";
  }

  if (number === 0) {
    return "0";
  }

  let isNegative = number < 0;
  number = Math.abs(number);

  return (isNegative ? "-" : "") + number.toLocaleString("en-IN");
};

/**
 * Formats a date input for display with time.
 *
 * @param {string|Date} inputdate - The date to be formatted.
 * @returns {React.ReactElement} A JSX element displaying the formatted date and time.
 */
export const DateFormatter1 = (inputdate) => {
  if (inputdate) {
    let date = new Date(inputdate);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();
    let time = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    let milliseconds = date.getMilliseconds();

    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return (
      <>
        <div>{dt + "-" + month + "-" + year},</div>

        <div>{time + ":" + milliseconds}</div>
      </>
    );
  }
};

/**
 * Determines if the current device is mobile based on screen width.
 *
 * @returns {boolean} True if the screen width is less than 601 pixels, otherwise false.
 */
export const isMobile = () => {
  return window.innerWidth < 601;
};

/**
 * Contains route paths used in the application.
 */
export const Routepaths = {
  Procurement: "/",
  Lanes: "/lanes",
  "Shortlist LSPs": "/shortlist",
  Notifications: "/notifications",
  Schedule: "/schedule",
  "RFQ Documents": "/documents",
  "Request Documents": "/uploads",
  "Uploads by LSPs": "/uploadsbylsp",
  RateCards: "/rate-cards",
  // 'AnalyzeNow': '/analysisnow',
  Auction: "/auction",
  "Advance Auction": "/lane_auction",
  // 'AnalyzeNow': '/analyze-now'
};

export const Activity = () => {
  // return Axios.post(Urls.logURL, { "activity": "Session Logging", "application": "Lorri-Procure", "ip": sessionStorage.getItem("ClientIP"), "session_log": data })
};

/**
 * Navigates to a specified path using history.
 *
 * @param {Object} history - The history object used for navigation.
 * @param {string} path - The path to navigate to.
 */
export const navigate = (history, path) => {
  history.push({ pathname: path });
};

/**
 * Gets the current timestamp in ISO format.
 *
 * @returns {string} The current timestamp.
 */
export const currentRequestTimeStamp = () => new Date().toISOString();

/**
 * Gets the current path from the window location.
 *
 * @returns {string} The current path.
 */
export const getCurrentPath = () => window.location.pathname;

/**
 * Contains string constants for various activities.
 */
export const ActivityString = {
  ButtonClick: "Button clicked",
};

/**
 * Retrieves the image source URL for a logo.
 *
 * @param {string} logo - The name of the logo file.
 * @returns {string} The URL of the image source.
 */
export const getImageSrc = (logo) => {
  if (logo && logo.length > 1) return `${Urls.FileUrl}/${logo}`;
  return transport_alt;
};

/**
 * Validates if a file is non-null and has a size.
 *
 * @param {File} file - The file to validate.
 * @returns {boolean} True if the file is valid, otherwise false.
 */
export const validateFile = (file) => {
  if (file && file.size) {
    return true;
  } else {
    return false;
  }
};

/**
 * Checks if a given time value is valid, i.e., it is in the future.
 *
 * @param {string|Date} value - The time value to check.
 * @returns {boolean} True if the time is valid, otherwise false.
 */
export const isValidTime = (value) => {
  let selectedTime = new Date(value);
  let now = new Date();
  now.setMinutes(now.getMinutes() + 2);
  if (now.getTime() < selectedTime.getTime()) {
    return true;
  } else {
    return false;
  }
};

/**
 * Validates if a phone number is a 10-digit number.
 *
 * @param {string} value - The phone number to validate.
 * @returns {boolean} True if the phone number is valid, otherwise false.
 */
export const isValidPhoneNumber = (value) =>
  value && !isNaN(parseInt(value)) && parseInt(value).toString().length === 10;

/**
 * Checks if a value contains any characters.
 *
 * @returns {boolean} Always returns false.
 */
export const containsCharcters = () => {
  return false;
};

/**
 * Validates if an email address is in a correct format.
 *
 * @param {string} value - The email address to validate.
 * @returns {boolean} True if the email address is valid, otherwise false.
 */
export const isValidEmail = (value) =>
  value && /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(value);
/**
 * Validates if a file name is valid based on a given regex pattern.
 *
 * @param {string} value - The file name to validate.
 * @returns {boolean} True if the file name is valid, otherwise false.
 */
export const isValidFileName = (value) =>
  value && new RegExp(/^[a-zA-Z0-9_-]+\.[a-zA-Z0-9]+$/).test(value);

/**
 * Checks if a value contains any special characters.
 *
 * @param {string} value - The value to check.
 * @returns {boolean} True if special characters are present, otherwise false.
 */
export const hasSpecialCharacters = (value) =>
  value && new RegExp(/[!@#$%^&*+\-=\[\]{}();':"\\|<>\/?]+/).test(value);

/**
 * Checks if a value contains special characters used for procurement names.
 *
 * @param {string} value - The value to check.
 * @returns {boolean} True if special characters are present, otherwise false.
 */
export const hasSpecialCharactersforProcurename = (value) =>
  value && new RegExp(/[!@#$%^&*+\-=\[\]{};'"\\|<>\/?]+/).test(value);

/**
 * Checks if a value contains special characters excluding brackets.
 *
 * @param {string} value - The value to check.
 * @returns {boolean} True if special characters are present, otherwise false.
 */
export const hasSpecialCharactersWithoutBrackets = (value) =>
  value && new RegExp(/[!@#$%^&*+\-=\[\]{};':"\\|,.<>\/?]+/).test(value);

/**
 * Checks if a value contains invalid address characters.
 *
 * @param {string} value - The value to check.
 * @returns {boolean} True if invalid address characters are present, otherwise false.
 */
export const isInvalidAddress = (value) =>
  value && new RegExp(/[!@#$%^&*_+\-=\[\]{};':"\\|.<>\/?]+/).test(value);

/**
 * Validates if a value is a number.
 *
 * @param {string} value - The value to validate.
 * @returns {boolean} True if the value is a valid number, otherwise false.
 */
export const isValidNumber = (value) =>
  value && new RegExp(/^[0-9.,\-]+$/).test(value);

/**
 * Validates if a value is an integer.
 *
 * @param {string} value - The value to validate.
 * @returns {boolean} True if the value is a valid integer, otherwise false.
 */
export const isInvalidNumber = (value) =>
  value && new RegExp(/^[0-9]+$/).test(value);

/**
 * Checks if a value contains SQL injection queries.
 *
 * @param {string} value - The value to check.
 * @returns {boolean} True if SQL injection queries are present, otherwise false.
 */
export const hasSQLInjectionQueries = (value) =>
  value &&
  new RegExp(
    /\b(DELETE|UPDATE|SELECT|INSERT|DROP|ALTER|SLEEP|WAITFOR)\b[\s\S]*\b(FROM|INTO|TABLE|DATABASE)\b/
  ).test(value);


/**
 * Checks if a value contains a range of SQL injection queries.
 *
 * @param {string} value - The value to check.
 * @returns {boolean} True if SQL injection queries are present, otherwise false.
 */
export const hasSQLInjectionQueries1 = (value) => {
  if (typeof value !== 'string') {
    return false;
  }

  // const sqlRegex = /(\bSELECT\b|\bUPDATE\b|\bINSERT\b|\bDROP\b|\bTRUNCATE\b|\bALTER\b|\bEXEC\b|\bFETCH\b|\bKILL\b|\bLOCK\b|\bUNLOCK\b|\bBACKUP\b|\bRESTORE\b|\bHANDLER\b|\bOPTIMIZE\b|\bRELEASE\b|\bSAVEPOINT\b|\bCHECKPOINT\b|\bCOMMIT\b|\bROLLBACK\b|\bLOOP\b|\bFOREACH\b|\bTHROW\b|\bTHROWS\b|\bUNION\b|\bJOIN\b|\bGROUP BY\b|\bORDER BY\b|\bEXISTS\b|\bIS NULL\b|\bIS NOT NULL\b|\bEND\b|\bTRUE\b|\bFALSE\b|\bNULL\b|\bBIT\b|\bEXTRACT\b|\bDATEADD\b|\bDATEDIFF\b|\bDAY\b|\bMONTH\b|\bYEAR\b|\bHOUR\b|\bMINUTE\b|\bSECOND\b|\bGETDATE\b|\bCURRENT_TIMESTAMP\b|\bUTC_TIMESTAMP\b|\bSYSDATE\b|\bDATABASE\b|\bCOLUMN\b|\bSCHEMA\b|\bPROCEDURE\b|\bFUNCTION\b|\bTRIGGER\b|\bINDEX\b|\bCONSTRAINT\b|\bPRIMARY KEY\b|\bFOREIGN KEY\b|\bAUTO_INCREMENT\b|\bREFERENCES\b|\bGRANT\b|\bREVOKE\b|\bEXECUTE\b|\bSELECT\s*\*\s*FROM|\bSLEEP\s*\(\s*\d+\s*\))/i;

  // return sqlRegex.test(value);
  return false
};

/**
 * Retrieves an ID based on the given path.
 *
 * @param {string} path - The path to get the ID for.
 * @returns {string} The corresponding ID for the path.
 */
export const getId = (path) => {
  switch (path) {
    case "/":
      return "Tenders_Click";
    // case '/Edit': return 'EditTender_Click'
    case "/Analytics":
      return "AnalyzeTender_Click";
    case "/Shortlist":
      return "Shortlist_Click";
    case "/Documents":
      return "Documents_Click";
    case "Logout":
      return "LogMeOff";
    default:
      return "";
  }
};

/**
 * Gets the procurement ID from the current URL path.
 *
 * @returns {string} The procurement ID or an empty string if not present.
 */
export const getProcurementID = () => {
  return window.location.pathname.split("/")[2]
    ? window.location.pathname.split("/")[2]
    : "";
};

/**
 * Gets the Auction ID from the current URL path.
 * @returns {string} The Auction ID or an empty string if not present.
 */
export const getAuctionID = () => {
  return window.location.pathname.split("/")[2]
    ? window.location.pathname.split("/")[2]
    : "";
};

/**
 * Contains details for rate card including unit volumes and time horizons.
 */
export const rateCardDetails = {
  unitVolumes: [
    {
      label: "in MT",
      value: "in MT",
    },
    {
      label: "in Truck Loads",
      value: "in Truck Loads",
    },
  ],
  timeHorizones: [
    {
      label: "Annually",
      value: "Annually",
    },
    {
      label: "Quarterly",
      value: "Quarterly",
    },
    {
      label: "Monthly",
      value: "Monthly",
    },
    {
      label: "Daily",
      value: "Daily",
    },
  ],
};

/**
 * Contains headers for the rate card preview table.
 */
export const rateCardPreviewTableHeaders = [
  "Sr. No.",
  "Origin",
  "Destination",
  "Volume",
  "Allowed Truck Types",
  "Rate",
  "Transit Time",
];

/**
 * Contains headers for the rate card.
 */
export const rateCardHeaders = [
  "Sr. No.",
  "Origin",
  "Destination",
  "Contract Tenure",
  "Volume",
  "Unit",
  "Allowed Truck Types",
  "Rate",
  "Transit time (in days)",
];

/**
 * Contains static headers for the master rate card.
 */
export const masterRateCardStaticHeades = [
  "Sr. No.",
  "Origin",
  "Destination",
  "Contract Tenure",
  "Volume",
  "Unit",
  "Proposed Truck Type",
];

/**
 * Validates if a number matches a given regex pattern.
 *
 * @param {string} number - The number to validate.
 * @returns {boolean} True if the number is valid, otherwise false.
 */
export const validNumberRegEx = (number) => {
  if (typeof number !== "undefined") {
    return /^[0-9.,\-]+$/.test(number);
  }
  return false;
};

/**
 * Contains options for auction bucket statuses.
 */
export const auctionBucketOptions = [
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Paused",
    value: "paused",
  },
  {
    label: "Upcoming",
    value: "upcoming",
  },
  {
    label: "Closed",
    value: "closed",
  },
].map((opt, i) => ({
  ...opt,
  id: i + 1,
}));

/**
 * Contains options for procurement bucket statuses.
 */
export const procureBucketOptions = [
  {
    label: "Upcoming",
    value: "approved",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Closed",
    value: "closed",
  },
].map((opt, i) => ({
  ...opt,
  id: i + 1,
}));

export const DateFormatter2 = (inputdate) => {
  if (inputdate) {
    let date = new Date(inputdate);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();
    let time = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    let milliseconds = date.getMilliseconds();

    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return (
      <>
        <span>{dt + "-" + month + "-" + year}</span>
      </>
    );
  }
};

export const DateFormatter3 = (inputdate) => {
  if (inputdate) {
    let date = new Date(inputdate);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();
    let time = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });

    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return (
      <>
        <span>{dt + "-" + month + "-" + year} </span>
      </>
    );
  }
};

export const userBucketOptions = [
  {
    label: "My Procurements",
    value: "user_view",
  },
  {
    label: "Company Procurements",
    value: "company_view",
  }
].map((opt, i) => ({
  ...opt,
  id: i + 1,
}));

export const buBucketOptions = [
  {
    label: "My Procurements",
    value: "user_view",
  },
  {
    label: "Company Procurements",
    value: "company_view",
  }
].map((opt, i) => ({
  ...opt,
  id: i + 1,
}));

//   export const checkEmptyField = (ObjectValuesTobeChecked) => {
//     console.log(ObjectValuesTobeChecked,"obj");
//     for (const key in ObjectValuesTobeChecked) {
//       if(key !== "lot_no"){
//         const formattedKey = key
//             .replace(/_/g, ' ')
//             .replace(/(^\w|_\w)/g, match => match.replace('_', '').toUpperCase())
//         if (!ObjectValuesTobeChecked[key] || hasSQLInjectionQueries1(ObjectValuesTobeChecked[key])) {
//             toast.error(`Please enter valid ${formattedKey}`);
//             return false;
//         }
//       }
//     }
//     return true;
// }

/**
 * Checks if any of the fields in the provided object are empty or invalid.
 * @param {Object} ObjectValuesTobeChecked - The object containing fields to be checked.
 * @returns {boolean} Returns `true` if all fields are valid, otherwise returns `false`.
 */
export const checkEmptyField = (ObjectValuesTobeChecked) => {
  // Iterate over each key in the object
  for (const key in ObjectValuesTobeChecked) {
    const value = ObjectValuesTobeChecked[key];
    // Skip validation for specific keys if the value is empty, null, or undefined
    // if (key === "transit_time" || key === "cargo_type" || key === "lot_no" || key === "origin_state" || key === "destination_state" || key === "origin_lat" || key === "origin_long" || key === "destination_lat" || key === "destination_long" || key === "volume" || key === "distance" || key === "fuel" || key === "toll" || key === "lowest_rate" || key === "last_freight_rate") {
    //   if (value === "" || value === null || value === undefined || value === 0) {
    //     continue;
    //   }
    // }
    if (key === "origin_name" || key === "destination_name" || key === "lane_no" || key === "truck_type") {
      if (typeof value === 'number') {
        if (value <= 0) {
          // Format the key for error message
          const formattedKey = key
            .replace(/_/g, ' ')
            .replace(/(^\w|_\w)/g, match => match.replace('_', '').toUpperCase());
          toast.error(`Please enter a valid value for ${formattedKey}`);
          return false;
        }
      } else {
        // Format the key for error message
        const formattedKey = key
          .replace(/_/g, ' ')
          .replace(/(^\w|_\w)/g, match => match.replace('_', '').toUpperCase());

        // Validate non-numeric values
        if (!value) {
          toast.error(`Please enter valid ${formattedKey}`);
          return false;
        }
      }
    }
  }

  // All fields are valid
  return true;
}

/**
 * Contains URLs for standard templates.
 */
/**
 * Contains URLs for standard templates.
 */
export const STANDARDTEMPLATES = {
  "rateCard": "https://lnclientdata.blob.core.windows.net/standardformat/StandardFormat.xlsx",
  "bulkAuctions" : "auctions/Auction_bulk_upload_template.xlsx",
  "bulkLanes" : "https://lorrifilestest.blob.core.windows.net/private-container/auctions/Bulk_upload_lanes_in_auctions.xlsx"
}

/**
 * Handles user logout and tracks the event in Mixpanel.
 *
 * @returns {Promise<void>} A promise that resolves once the user is logged out.
 */
export const Logmeout = async (auth) => {
  mixpanel.track(`User has clicked on logout`, {
    ApplicationName: `${Urls.mixpanelappname}`,
    ScreenName: 'LoRRI-Header',
    ModuleName: 'landing_page',
    ActivityLog: 'userClickedLogOut',
    Data: `None`,
    Definition: `User has clicked on logout`,
    ActivityType: 'event_view',
    UserName: `${localStorage.getItem("userdetails")}`,
    UserEmail: `${localStorage.getItem("useremail")}`,
    CompanyName: `${localStorage.getItem("companyname")}`
  });
  // sessionStorage.removeItem("accessToken")
  localStorage.removeItem("user_name")
  await logout(auth)
  window.location.href = CLIENT_REDIRECT_BASE
};
